<vi-panel
  data-at-user-panel
  [ngClass]="{ hidden: !gatewaysVM.gateways?.length }"
  title="{{ '+USER_DETAILS.GATEWAYS.TITLE' | translate }}"
>
  <div
    *ngIf="user.customerNumber"
    title
    class="invitations-button-wrapper flex flex-row justify-end items-center xs:justify-center"
  >
    <button
      data-at-show-all-invitations
      id="show-all-invitations"
      mat-stroked-button
      color="primary"
      gtm="onOpen"
      gtmAction="All gateway`s invitations list"
      gtmCategory="userDetails"
      (click)="showAllInvitations()"
    >
      {{ '+USER_DETAILS.GATEWAYS.BUTTON.SHOW_ALL_INVITATIONS' | translate }}
    </button>
  </div>
  <div content class="list-item-wrapper flex flex-col justify-start items-start">
    <div>
      <div
        class="list-item-header !flex flex-row justify-start items-center"
        [class.with-scrollbar]="gatewaysVM.gateways.length > 7"
      >
        <div class="flex-[10%] max-w-[10%]">
          {{ '+USER_DETAILS.GATEWAYS.NUMBER' | translate }}
        </div>
        <div class="installationAddress flex-[27%] max-w-[27%]">
          {{ '+USER_DETAILS.GATEWAYS.ADDRESS' | translate }}
        </div>
        <div class="serial flex-[27%] max-w-[27%]">
          {{ '+USER_DETAILS.GATEWAYS.SERIAL' | translate }}
        </div>
        <div class="type flex-[27%] max-w-[27%]">
          {{ '+USER_DETAILS.GATEWAYS.TYPE' | translate }}
        </div>
        <div class="status flex flex-row justify-center items-center flex-[9%] max-w-[9%]">
          {{ '+USER_DETAILS.GATEWAYS.STATUS' | translate }}
        </div>
      </div>
      <app-infinite-scroll
        [limit]="limit"
        [state$]="gatewaysState$"
        [search$]="type$"
        [itemSize]="itemSize"
        [(nextBatch)]="nextBatch"
        (fetchNext)="onFetchNext()"
        (nextBatchChange)="onNextBatchChange($event)"
      >
        <cdk-virtual-scroll-viewport [itemSize]="itemSize" class="scroll-overflow">
          <a
            class="list-item !flex flex-row justify-start items-center"
            [attr.data-at-gateway-item]="item.serial"
            *cdkVirtualFor="let item of gatewaysVM.gateways; let index = index"
            gtm="onGoToPage"
            gtmAction="Installation"
            gtmCategory="userDetails"
            (click)="navigateToInstallation(item)"
          >
            <div class="flex-[10%] max-w-[10%]">
              {{ index + 1 }}
            </div>
            <div class="installationAddress flex-[27%] max-w-[27%]">
              <div>
                {{ item.installationAddress?.street }} {{ item.installationAddress?.houseNumber }}
              </div>
              <div>
                {{ item.installationAddress?.zip }} {{ item.installationAddress?.city }},
                {{ item.installationAddress?.country }}
              </div>
            </div>
            <div class="serial flex-[27%] max-w-[27%]">{{ item.serial }}</div>
            <div class="type flex-[27%] max-w-[27%]">
              {{ item.marketingName || item.gatewayType }}
            </div>
            <div class="status flex flex-row justify-center items-center flex-[9%] max-w-[9%]">
              <ng-container *ngIf="item.isColdSystem">
                <mat-icon class="cold-system-icon" [matTooltip]="coldSystemTooltip | translate"
                  >cancel</mat-icon
                >
              </ng-container>
              <ng-container [ngSwitch]="item.aggregatedStatus">
                <span matTooltip="{{ item.aggregatedStatus | translateAggregatedStatus }}">
                  <mat-icon *ngSwitchCase="aggregatedStatus.Offline" class="offline-mode"
                    >wifi_off</mat-icon
                  >
                  <mat-icon
                    *ngSwitchCase="aggregatedStatus.WorksProperly"
                    class="works-properly-icon"
                    >check_circle</mat-icon
                  >
                  <mat-icon *ngSwitchCase="aggregatedStatus.Error" class="error-icon"
                    >error</mat-icon
                  >
                  <vi-icon
                    icon
                    *ngSwitchCase="aggregatedStatus.Maintenance"
                    name="maintenance"
                    [size]="18"
                  ></vi-icon>
                </span>
              </ng-container>
            </div>
          </a>
          <vi-loader
            *ngIf="nextBatch"
            [isLoading]="true"
            [message]="'+USER_DETAILS.GATEWAYS.FETCHING_MORE_GATEWAYS' | translate"
          ></vi-loader>
        </cdk-virtual-scroll-viewport>
      </app-infinite-scroll>
    </div>
  </div>
</vi-panel>
<vi-panel
  *ngIf="!gatewaysVM.gateways?.length && !gatewaysVM.isLoading"
  title="{{ '+USER_DETAILS.GATEWAYS.TITLE' | translate }}"
>
  <div content class="flex flex-row justify-center items-center">
    <app-banner *ngIf="!showNoPermissionInfo">
      {{ '+USER_DETAILS.GATEWAYS.NO_GATEWAYS' | translate: { user: userName } }}
    </app-banner>
    <app-banner *ngIf="showNoPermissionInfo">
      {{ '+USER_DETAILS.GATEWAYS.NO_PERMISSION' | translate }}
    </app-banner>
  </div>
</vi-panel>
<vi-panel *ngIf="gatewaysVM.isLoading" title="{{ '+USER_DETAILS.GATEWAYS.TITLE' | translate }}">
  <div content class="flex flex-row justify-center items-center">
    <vi-loader
      data-at-loader
      message="{{ '+USER_DETAILS.GATEWAYS.LOADING_MESSAGE' | translate }}"
      [isLoading]="true"
    ></vi-loader>
  </div>
</vi-panel>
